import { lazy } from 'react'

// Pages
export const Home = lazy(() => import('../../routes/Home'))
export const PartsCatalog = lazy(() => import('../../routes/PartsCatalog'))
export const Cart = lazy(() => import('../../routes/CartRoute'))
export const SearchResults = lazy(() => import('../../routes/SearchResults'))
export const ProductDetails = lazy(() => import('../../routes/ProductDetails'))
export const VehicleHistory = lazy(() => import('../../routes/VehicleHistory'))
export const OrderHistory = lazy(() => import('../../features/orderHistory'))
export const Lists = lazy(() => import('../../features/lists'))
export const QuotesPage = lazy(() => import('quotes'))
export const Login = lazy(() => import('../../routes/Login'))
export const SendCode = lazy(() => import('../../routes/SendCode'))
export const ContactAdmin = lazy(() => import('../../routes/ContactAdmin'))
export const ResetPassword = lazy(() => import('../../routes/ResetPassword'))
export const AutoLogin = lazy(() => import('../../routes/AutoLogin'))
export const AstPartsCatalog = lazy(
  () => import('../../routes/AstPartsCatalog')
)
export const QuotesDetails = lazy(() => import('../../routes/QuotesDetails'))
export const OrderDetails = lazy(
  () => import('../../features/orderHistory/components/OrderDetails')
)
export const OrderConfirmation = lazy(
  () => import('../../routes/OrderConfirmation')
)
export const CrossReferencePage = lazy(
  () => import('../../routes/CrossReference')
)
export const NotFoundPage = lazy(() => import('../../routes/NotFound'))
